// extracted by mini-css-extract-plugin
module.exports = {"label":"_a4de3d00","value":"_1d72f0ed"};